<div class="dialog-content">
  <h1 mat-dialog-title class="col-12 dialogTitle">{{data.dialogTitle}}</h1>

  <div class="dialog-body">
    <ng-template [ngIf]="data.dialogMode === 'add'">
      <mat-form-field class="col-12">
        <mat-label>Type</mat-label>
        <mat-select [(value)]="data.type">
          <mat-option *ngFor="let type of data.stepTypes" [value]="type.value">
            {{type.viewValue}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-template>

    <mat-form-field class="col-12">
      <input matInput [(ngModel)]="data.name" placeholder="Name">
    </mat-form-field>

    <div class="row col-12">
      <mat-form-field class="col-6">
        <input matInput [(ngModel)]="data.groupName" placeholder="Group Name" (ngModelChange)="!data.groupName && (data.overlapStep = false)">
      </mat-form-field>

      <mat-slide-toggle class="col-6" [(ngModel)]="data.overlapStep" [disabled]="!data.groupName">
        Overlap
      </mat-slide-toggle>
    </div>

    <mat-form-field class="col-6">
      <input matInput [(ngModel)]="data.duration" placeholder="Duration">
    </mat-form-field>

    <mat-form-field class="col-6">
      <mat-label>Unit</mat-label>
      <mat-select [(value)]="data.unit">
        <mat-option *ngFor="let unit of data.units" [value]="unit.value">
          {{unit.viewValue}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <ng-template [ngIf]="data.type === 'option' || data.type === 'option2'">
      <mat-form-field class="col-12">
        <mat-label>Enabled by</mat-label>
        <mat-select [(value)]="data.enabledBy">
          <mat-option *ngFor="let item of data.items" [value]="item.value">
            {{item.viewValue}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-template>

    <mat-form-field class="col-12">
      <mat-label>Follows</mat-label>
      <mat-select [(value)]="data.follows">
        <mat-option *ngFor="let item of data.allItems" [value]="item.value">
          {{item.viewValue}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <ng-template [ngIf]="data.type === 'option2' || data.type === 'fixedSelection'">
      <div class="col-12">
        <mat-label><strong>Selection Items</strong></mat-label>
        <button mat-icon-button color="primary" (click)="addSubStep()"><mat-icon>add</mat-icon></button>
      </div>
      <ng-template ngFor let-item [ngForOf]="data.selectItems" let-i="index">
        <mat-form-field class="col-3">
          <input matInput [(ngModel)]="data.selectItems[i].name" placeholder="Name">
        </mat-form-field>
        <mat-form-field class="col-2">
          <input matInput [(ngModel)]="data.selectItems[i].duration" placeholder="Duration">
        </mat-form-field>
        <mat-form-field class="col-2">
          <mat-label>Unit</mat-label>
          <mat-select [(value)]="data.selectItems[i].unit">
            <mat-option *ngFor="let unit of data.units" [value]="unit.value">
              {{unit.viewValue}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="col-2">
          <input matInput [(ngModel)]="data.selectItems[i].cost" [value]="formatRange(data.selectItems[i].cost)" placeholder="Official" (blur)="onCostBlur(i)">
        </mat-form-field>
        <mat-form-field class="col-2">
          <input matInput [(ngModel)]="data.selectItems[i].professional" [value]="formatRange(data.selectItems[i].professional)" placeholder="Professional" (blur)="onProfessionalBlur(i)">
        </mat-form-field>
        <button mat-icon-button color="primary" (click)="deleteSubStep(i)"><mat-icon>delete</mat-icon></button>
      </ng-template>
    </ng-template>

    <ng-template [ngIf]="data.type !== 'option2' && data.type !== 'fixedSelection'">
      <mat-form-field class="col-6">
        <input matInput class="example-right-align" [(ngModel)]="formattedCost" (ngModelChange)="onCostChange($event)" placeholder="Official">
        <span matPrefix>$&nbsp;</span>
      </mat-form-field>

      <mat-form-field class="col-6">
        <input matInput class="example-right-align" [(ngModel)]="formattedProfessional" (ngModelChange)="onProfessionalChange($event)" placeholder="Professional">
        <span matPrefix>$&nbsp;</span>
      </mat-form-field>
    </ng-template>

    <div class="col-12">
      <mat-label><strong>User Inputs</strong></mat-label>
      <!--<button mat-icon-button color="primary" (click)="addUserInput()"><mat-icon>add</mat-icon></button>-->
    </div>

    <div *ngFor="let item of data.userInput; let i = index">
      <mat-checkbox class="me-2 ms-3"
                    [(ngModel)]="item.selected"
                    [name]="'checkbox-' + i">
      </mat-checkbox>

      <mat-form-field class="col-7">
        <input matInput
               [(ngModel)]="item.name"
               [disabled]="true"
               class="custom-disabled" />
      </mat-form-field>

      <mat-form-field class="col-2">
        <input matInput
               [(ngModel)]="item.official"
               placeholder="Official" />
      </mat-form-field>

      <mat-form-field class="col-2">
        <input matInput
               [(ngModel)]="item.professional"
               placeholder="Professional" />
      </mat-form-field>
    </div>

  </div>



  <div class="col-12 mb-3">
    <mat-dialog-actions align="end">
      <button class="dialog-step-CancelButton" mat-raised-button (click)="onClickCancel()">Cancel</button>
      <button class="dialog-step-SaveButton" mat-raised-button color="primary" [mat-dialog-close]="data" cdkFocusInitial>Ok</button>
    </mat-dialog-actions>
  </div>
</div>
